import { useEffect } from 'react';
import { useBrand } from '@hcsc-fiber/react';
import { BRAND_CODES } from './constants';
import { setBrandContext } from './brandContext';

const FiberBrandSync: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const { brand } = useBrand();

  useEffect(() => {
    setBrandContext(
      brand === BRAND_CODES.HEALTHSPRING ? BRAND_CODES.HEALTHSPRING : BRAND_CODES.BCBS,
    );
  }, [brand]);

  return children;
};

export default FiberBrandSync;


